import { _ as _defineProperty, b as _createClass, e as _classCallCheck } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.fill.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import { getPixelRatio } from '../global/dom.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/web.dom-collections.iterator.js';

var modules_00b5ad26 = {"light":"light_rui_2ac4","canvas":"canvas_rui_eff2","animate":"animate_rui_eff2","rotation-keyframes":"rotation-keyframes_rui_eff2","text":"text_rui_eff2"};

var INITIAL_TICKS = 100;
var Particle = /*#__PURE__*/function () {
  function Particle(_ref) {
    var x = _ref.x,
      y = _ref.y,
      radius = _ref.radius,
      color = _ref.color;
    _classCallCheck(this, Particle);
    _defineProperty(this, "radius", void 0);
    _defineProperty(this, "x", void 0);
    _defineProperty(this, "y", void 0);
    _defineProperty(this, "color", void 0);
    _defineProperty(this, "decay", void 0);
    _defineProperty(this, "life", void 0);
    this.radius = radius;
    this.x = x;
    this.y = y;
    this.color = color;
    this.decay = 0.01;
    this.life = 1;
  }
  return _createClass(Particle, [{
    key: "step",
    value: function step() {
      this.life -= this.decay;
    }
  }, {
    key: "isAlive",
    value: function isAlive() {
      return this.life >= 0;
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      var alpha = this.life >= 0 ? this.life : 0;
      ctx.fillStyle = "rgba(".concat(this.color.r, ", ").concat(this.color.g, ", ").concat(this.color.b, ", ").concat(alpha, ")");
      ctx.beginPath();
      ctx.arc(this.x + this.radius, this.y + this.radius, this.radius, 0, Math.PI * 2);
      ctx.fill();
    }
  }]);
}();
var DETERMINISTIC_VALUE = 0.5;
function deterministic() {
  return DETERMINISTIC_VALUE;
}
var LoaderCore = /*#__PURE__*/function () {
  function LoaderCore(containerNode, props) {
    var _this$ctx;
    _classCallCheck(this, LoaderCore);
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "canvas", void 0);
    _defineProperty(this, "textNode", void 0);
    _defineProperty(this, "ctx", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "particles", void 0);
    _defineProperty(this, "baseSpeed", void 0);
    _defineProperty(this, "colorIndex", void 0);
    _defineProperty(this, "maxRadius", void 0);
    _defineProperty(this, "minRadius", void 0);
    _defineProperty(this, "colorChangeTick", void 0);
    _defineProperty(this, "x", void 0);
    _defineProperty(this, "y", void 0);
    _defineProperty(this, "radius", void 0);
    _defineProperty(this, "hSpeed", void 0);
    _defineProperty(this, "vSpeed", void 0);
    _defineProperty(this, "radiusSpeed", void 0);
    _defineProperty(this, "tick", void 0);
    _defineProperty(this, "isRunning", void 0);
    this.props = Object.assign({}, LoaderCore.defaultProps, props);
    this.canvas = document.createElement('canvas');
    this.canvas.dataset.test = 'ring-loader';
    this.canvas.classList.add(modules_00b5ad26.canvas);
    this.textNode = document.createElement('div');
    this.textNode.dataset.test = 'ring-loader-text';
    this.textNode.classList.add(modules_00b5ad26.text);
    this.textNode.textContent = this.props.message ? this.props.message : '';
    containerNode.appendChild(this.canvas);
    containerNode.appendChild(this.textNode);
    var pixelRatio = LoaderCore.getPixelRatio();
    var canvasSize = this.props.size * pixelRatio;
    this.canvas.width = canvasSize;
    this.canvas.height = canvasSize;
    //Fixate canvas physical size to avoid real size scaling
    this.canvas.style.width = "".concat(this.props.size, "px");
    this.canvas.style.height = "".concat(this.props.size, "px");
    this.ctx = this.canvas.getContext('2d');
    (_this$ctx = this.ctx) === null || _this$ctx === void 0 || _this$ctx.scale(pixelRatio, pixelRatio);
    this.height = this.props.size;
    this.width = this.props.size;
    this.particles = [];
    //Configuration
    this.baseSpeed = 1.0;
    this.colorIndex = 0;
    this.maxRadius = 10;
    this.minRadius = 6;
    this.colorChangeTick = 40;
    //State
    this.x = 0;
    this.y = 0;
    this.radius = 8;
    this.hSpeed = 1.5;
    this.vSpeed = 0.5;
    this.radiusSpeed = 0.05;
    this.tick = 0;
    this.prepareInitialState(INITIAL_TICKS);
    this.isRunning = !this.props.stop;
    if (this.isRunning) {
      this.startAnimation();
    } else {
      this.draw();
    }
  }
  return _createClass(LoaderCore, [{
    key: "prepareInitialState",
    value: function prepareInitialState(ticks) {
      for (var i = 0; i < ticks; i++) {
        this.step();
      }
    }
  }, {
    key: "handleLimits",
    value: function handleLimits(coord, radius, speed, limit) {
      var randomFunc = this.props.deterministic ? deterministic : Math.random;
      var randomizedSpeedChange = randomFunc() - this.baseSpeed / 2;
      if (coord + radius * 2 + this.baseSpeed >= limit) {
        return -(this.baseSpeed + randomizedSpeedChange);
      } else if (coord <= this.baseSpeed) {
        return this.baseSpeed + randomizedSpeedChange;
      }
      return speed;
    }
  }, {
    key: "calculateNextCoordinates",
    value: function calculateNextCoordinates() {
      this.x += this.hSpeed;
      this.y += this.vSpeed;
      this.hSpeed = this.handleLimits(this.x, this.radius, this.hSpeed, this.width);
      this.vSpeed = this.handleLimits(this.y, this.radius, this.vSpeed, this.height);
    }
  }, {
    key: "calculateNextRadius",
    value: function calculateNextRadius() {
      this.radius += this.radiusSpeed;
      if (this.radius > this.maxRadius || this.radius < this.minRadius) {
        this.radiusSpeed = -this.radiusSpeed;
      }
    }
  }, {
    key: "getNextColor",
    value: function getNextColor() {
      var colors = this.props.colors;
      var currentColor = colors[this.colorIndex];
      var nextColor = colors[this.colorIndex + 1] || colors[0];
      return LoaderCore.calculateGradient(currentColor, nextColor, this.tick / this.colorChangeTick);
    }
  }, {
    key: "nextTick",
    value: function nextTick() {
      this.tick++;
      if (this.tick > this.colorChangeTick) {
        this.tick = 0;
        this.colorIndex++;
        if (this.colorIndex > this.props.colors.length - 1) {
          this.colorIndex = 0;
        }
      }
    }
  }, {
    key: "step",
    value: function step() {
      this.nextTick();
      this.calculateNextCoordinates();
      this.calculateNextRadius();
      this.particles.forEach(function (particle) {
        return particle.step();
      });
      this.particles.push(new Particle({
        x: this.x,
        y: this.y,
        radius: this.radius,
        color: this.getNextColor()
      }));
    }
  }, {
    key: "removeDeadParticles",
    value: function removeDeadParticles() {
      this.particles = this.particles.filter(function (it) {
        return it.isAlive();
      });
    }
  }, {
    key: "draw",
    value: function draw() {
      var ctx = this.ctx;
      if (ctx == null) {
        return;
      }
      ctx.clearRect(0, 0, this.width, this.height);
      this.removeDeadParticles();
      this.particles.forEach(function (particle) {
        return particle.draw(ctx);
      });
    }
  }, {
    key: "loop",
    value: function loop() {
      var _this = this;
      this.step();
      this.draw();
      if (this.isRunning) {
        window.requestAnimationFrame(function () {
          return _this.loop();
        });
      }
    }
  }, {
    key: "updateMessage",
    value: function updateMessage(text) {
      this.textNode.textContent = text || '';
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      this.isRunning = false;
      this.canvas.classList.remove(modules_00b5ad26.animate);
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      this.isRunning = true;
      this.canvas.classList.add(modules_00b5ad26.animate);
      this.loop();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.isRunning = false;
    }
  }], [{
    key: "calculateGradient",
    value: function calculateGradient(startColor, stopColor, position) {
      var calculateChannelValue = function calculateChannelValue(a, b) {
        return a + Math.round((b - a) * position);
      };
      return {
        r: calculateChannelValue(startColor.r, stopColor.r),
        g: calculateChannelValue(startColor.g, stopColor.g),
        b: calculateChannelValue(startColor.b, stopColor.b)
      };
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio$1() {
      return getPixelRatio();
    }
  }]);
}();
_defineProperty(LoaderCore, "defaultProps", {
  size: 64,
  stop: false,
  deterministic: false,
  colors: [{
    r: 215,
    g: 60,
    b: 234
  },
  //#D73CEA
  {
    r: 145,
    g: 53,
    b: 224
  },
  //#9135E0
  {
    r: 88,
    g: 72,
    b: 224
  },
  //#5848F4
  {
    r: 37,
    g: 183,
    b: 255
  },
  //#25B7FF
  {
    r: 89,
    g: 189,
    b: 0
  },
  //#59BD00
  {
    r: 251,
    g: 172,
    b: 2
  },
  //#FBAC02
  {
    r: 227,
    g: 37,
    b: 129
  } //#E32581
  ]
});

export { LoaderCore as default };
